export default __webpack_public_path__ + "static/media/ProximaNova-Bold.0c6a3b17.ttf";